import React, { Component } from 'react';
import {  Row, Col, Modal, ModalHeader, ModalBody, Label, FormGroup, Button, Spinner, Table } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Select from "react-select";
import toastr from 'toastr'
import { BaseUrl } from '../../helpers/Baseurl';
import "./dashboard.scss";

  
const PackegeTypeGroup = [
	{ 
		label: "Standard Packege Type",
		options: [
            { label: "Standard 2*", value: "Budget" },
            { label: "Standard 3*", value: "Standard" },
            
		]
	}
];

const ExecutiveTypeGroup = [
	{ 
		label: "Executive Packege Type",
		options: [
            { label: "Executive 2*", value: "Standard" },
            { label: "Executive 3*", value: "Deluxe" },
            { label: "Executive 4*", value: "Premium" },
            { label: "Executive 5*", value: "Platinum" },
		]
	}
];

const DaysGroup = [
	{ 
		label: "No. of Days",
		options: [
            { label: "1", value: 1 },
            { label: "2", value: 2 },
            { label: "3", value: 3 },
            { label: "4", value: 4 },
            { label: "5", value: 5 },
            { label: "6", value: 6 },
            { label: "7", value: 7 },
            { label: "8", value: 8 },
            { label: "9", value: 8 },
            { label: "10", value: 10 },
            { label: "11", value: 11 },

		]
	}
];

const PAXGroup = [
	{ 
		label: "No. of PAX",
		options: [
            { label: "2", value: 2 },
            { label: "3", value: 3 },
            { label: "4", value: 4 },
            { label: "5", value: 5 },
            { label: "6", value: 6 },
            { label: "7", value: 7 },
            { label: "8", value: 8 },
            { label: "9", value: 8 },
            { label: "10", value: 10 },

		]
	}
];

const TeensGroup = [
	{ 
		label: "No. of Teens",
		options: [
            { label: "0", value: 0 },
            { label: "1", value: 1 },
            { label: "2", value: 2 },
            { label: "3", value: 3 },
            { label: "4", value: 4 },
            { label: "5", value: 5 },
            { label: "6", value: 6 },


		]
	}
];

const HotelMealType = [
    { 
		label: "Price",
		options: [
                { label: "EP", value: "ep" },
                { label: "CP", value: "cp" },
                { label: "MAP", value: "map" },
		]
	}
];

class Calculator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            print:false,
            calculated: false,
            model_type: false,
            model_pricing: false,
            typeloading:false,
            selectedPackegeType: { label: "Standard 2*", value: "Budget" },
            selectedMealType: { label: "EP", value: "ep" },
            selectedExecutivePackegeType: { label: "Executive 2*", value: "Standard" },
            selectedExecutiveMealType: { label: "EP", value: "ep" },
            selectedPAX: { label: "2", value: 2 },
            selectedTeens: { label: "0", value: 0 },
            selectedDays: { label: "Select No. of Days", value: null },
            selectedNights: { label: "Select No. of Nights", value: null },
            selectedDestinations: { label: "Select Destination", value: null },

            hotel_standard: null,
            hotel_executed: null,

            vehicle_standard: null,
            vehicle_executed: null,

            DestinationGroup:[],

            standard_onseason:0,
            standard_offseason:0,
            executed_onseason:0,
            executed_offseason:0,

            standard_onseason_tax:0,
            standard_offseason_tax:0,
            executed_onseason_tax:0,
            executed_offseason_tax:0,


            standard_onseason_matgin:0,
            standard_offseason_matgin:0,
            executed_onseason_matgin:0,
            executed_offseason_matgin:0,


            standard_onseason_total:0,
            standard_offseason_total:0,
            executed_onseason_total:0,
            executed_offseason_total:0,

            standard_onseason_perpax:0,
            standard_offseason_perpax:0,
            executed_onseason_perpax:0,
            executed_offseason_perpax:0,
            
        }
        this.tog_type = this.tog_type.bind(this);
        this.tog_pricing = this.tog_pricing.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this)

    }   

    componentDidCatch(error) {
        // Changing the state to true
        // if some error occurs
        console.log(error)
      }

    componentDidUpdate(preProps){
    if (preProps.data !== this.props.data){

    }
    }

    componentDidMount(){
        this.loadDestinationData('?parent=null')
    }
    
    tog_type() {
        this.setState(prevState => ({
          model_type: !prevState.model_type
        }));
        this.removeBodyCss();
    }

    tog_pricing() {
        this.setState(prevState => ({
            model_pricing: !prevState.model_pricing
        }));
        this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    handleSelectedPackegeType = selectedPackegeType =>{
        this.setState({ selectedPackegeType })
    }
    handleselectedDestinations = selectedDestinations =>{
        this.setState({ selectedDestinations })
    }

    onInputChange(e){
        this.loadDestinationData(`?parent=null&search=${e}`)
    }

    toPrint(){
        this.setState({print:true})
        setTimeout(() => {
            window.print()
            this.setState({print:false})
          }, 100);        
    }

    async loadDestinationData(filer_queryset){

        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'  },
        };
        await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let options = [{ label: 'Himachal', value: 0 }]
                    let shimla = false
                    let leh = false
                    data.results.map(destination => {
                        
                        let name = (destination.name).toLowerCase()
                        if (['ladakh', 'manali','leh', 'shimla', 'dharamshala', 'dalhousie', 'spiti valley', ].includes(name)){
                            if ((name === 'shimla'|| name === 'manali') && !shimla){
                                shimla = true
                                options.push({ label: 'Shimla - Manali', value: destination.id })
                            }else if((name === 'leh'|| name === 'ladakh') && !leh){
                                options.push({ label: 'Leh - Ladakh', value: destination.id })
                            }else{
                                options.push({ label: destination.name, value: destination.id })
                            }
                        }
                      })
                   
                      let DestinationGroup = [
                        { 
                            label: "Destination",
                            options: options
                        }
                    ];
                    this.setState({ DestinationGroup:DestinationGroup  })      
                   
                },
                (error) => {
                    console.log(error, 'error--------------') 
                }
            )  
       }

    handleSubmit(e, values) {
        const {selectedDestinations, selectedPAX, selectedTeens, selectedDays, selectedPackegeType, selectedExecutivePackegeType,
            selectedNights, selectedMealType,selectedExecutiveMealType } = this.state
        console.log(selectedDestinations)
        if (selectedDestinations.value === null){
            toastr.error("Select Destinations")
        }else if(!selectedDays.value){
            toastr.error("Select No of Days")
        }else if(!selectedDays.value){
            toastr.error("Select No of Nights")
        }else{
            this.setState({ typeloading: true })
            let data = {
                'destinations': [selectedDestinations.value],
                'pax': selectedPAX.value ,
                'teens': selectedTeens.value ,
                'day': selectedDays.value,
                'night': selectedNights.value,
                'standard': selectedPackegeType.value,
                'standard_meal': selectedMealType.value,
                'executive': selectedExecutivePackegeType.value,
                'executive_meal': selectedExecutiveMealType.value,
            }
            console.log(JSON.stringify(data))
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            };
            fetch(`${BaseUrl}/api/itineraries/calculate-pricing/`, requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json().then((resp) => {
                    let error = resp['non_field_errors']
                    if(error){
                        toastr.error("Role with Selected Module and Permissions already Created", "")
                    }else{
                        toastr.error("Somthing Went Wrong", "")
                    }
                    this.tog_type()
                    this.setState({typeloading:false})    
                    })
    
                }
                else{
                   res.json()
                   .then((data) => {
                    let hotel_standard = data.hotel.standard.hotel
                    let hotel_executed = data.hotel.executive.hotel

                    let vehicle_standard = data.vehicle.standard.vehicle
                    let vehicle_executed = data.vehicle.executive.vehicle

                    let standard_onseason = data.hotel.standard.on_season + data.vehicle.standard.on_season
                    let standard_offseason = data.hotel.standard.off_season + data.vehicle.standard.off_season
                    let executed_onseason = data.hotel.executive.on_season + data.vehicle.executive.on_season
                    let executed_offseason = data.hotel.executive.off_season + data.vehicle.executive.off_season

                    let standard_onseason_tax = parseInt((standard_onseason*5)/100)
                    let standard_offseason_tax = parseInt((standard_offseason*5)/100)
                    let executed_onseason_tax = parseInt((executed_onseason*5)/100)
                    let executed_offseason_tax = parseInt((executed_offseason*5)/100)

                    let standard_onseason_matgin = parseInt((standard_onseason*12)/100)
                    let standard_offseason_matgin = parseInt((standard_offseason*12)/100)
                    let executed_onseason_matgin = parseInt((executed_onseason*12)/100)
                    let executed_offseason_matgin = parseInt((executed_offseason*12)/100)

                    let standard_onseason_total = standard_onseason + standard_onseason_tax + standard_onseason_matgin
                    let standard_offseason_total = standard_offseason + standard_offseason_tax + standard_offseason_matgin
                    let executed_onseason_total = executed_onseason + executed_onseason_tax + executed_onseason_matgin
                    let executed_offseason_total = executed_offseason + executed_offseason_tax + executed_offseason_matgin

                    let standard_onseason_perpax = parseInt(standard_onseason_total/selectedPAX.value)
                    let standard_offseason_perpax = parseInt(standard_offseason_total/selectedPAX.value)
                    let executed_onseason_perpax = parseInt(executed_onseason_total/selectedPAX.value)
                    let executed_offseason_perpax = parseInt(executed_offseason_total/selectedPAX.value)
                    
                    this.setState({typeloading:false, standard_onseason, standard_offseason, executed_onseason, executed_offseason,
                        standard_onseason_tax, standard_offseason_tax, executed_onseason_tax, executed_offseason_tax,
                        standard_onseason_matgin, standard_offseason_matgin, executed_onseason_matgin, executed_offseason_matgin, 
                        standard_onseason_total, standard_offseason_total, executed_onseason_total, executed_offseason_total,
                        standard_onseason_perpax, standard_offseason_perpax, executed_onseason_perpax, executed_offseason_perpax,
                        hotel_standard, hotel_executed, vehicle_standard, vehicle_executed,
                        calculated:true,
                        })


                   })
                       
                }
                }
            )

        }
          
    }




    render() {
    
        return (
            <React.Fragment>
                <Row>
                    <Col sm={'6'}>
                    </Col>
                    <Col sm={'6'}>
                        <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2 float-end"
                            onClick={this.tog_type}
                        >
                            <i className="mdi mdi-plus me-1" />{" "}
                            Packege Price Calculator
                        </Button>
                        
                    </Col>  
                </Row>
                <Col sm={6} md={4} xl={3} className="mt-4">
               
                <Modal
                    size='fullscreen'
                    isOpen={this.state.model_type}
                    toggle={this.tog_type}
                    // centered={true}
                    scrollable={true}
                >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 {this.state.calculated? `${this.state.selectedDestinations.label} ${this.state.selectedDays.label} Days ${this.state.selectedNights.label} Nights Tour Packege` 
                 :'Calculate Packege Pricing'}
                 
                 </ModalHeader>
                 <ModalBody>
                    <Row>
                        <Col sm='3'>
                        </Col>
                        <Col sm='6'>
                            <AvForm className="needs-validation mb-2" onValidSubmit={this.handleSubmit} >
                                <Row>
                                        <Col md="12">
                                            <div className="mb-3">
                                                <Label className="form-label">Destinations</Label>
                                                <Select  
                                                    onInputChange={this.onInputChange}
                                                    value= {this.state.selectedDestinations}
                                                    onChange={this.handleselectedDestinations}
                                                    // isMulti={true}
                                                    options={this.state.DestinationGroup}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                                                        
                                    </Row>
                        
                                    <Row>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">No Of Days</Label>
                                                <Select  
                                                    value= {this.state.selectedDays}
                                                    onChange = {(e) => this.setState({selectedDays: e })}
                                                    options={DaysGroup}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">No Of Nights</Label>
                                                <Select  
                                                    value= {this.state.selectedNights}
                                                    onChange = {(e) => this.setState({selectedNights: e })}
                                                    options={DaysGroup}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">No. of PAX</Label>
                                                <Select  
                                                    value= {this.state.selectedPAX}
                                                    onChange = {(e) => this.setState({selectedPAX:e})}
                                                    options={PAXGroup}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">No. of Teens</Label>
                                                <Select  
                                                    value= {this.state.selectedTeens}
                                                    onChange = {(e) => this.setState({selectedTeens:e})}
                                                    options={TeensGroup}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                                                        
                                    </Row>

                                    <Row>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Standard Packege Type</Label>
                                                <Select  
                                                    value= {this.state.selectedPackegeType}
                                                    onChange = {this.handleSelectedPackegeType}
                                                    options={PackegeTypeGroup}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Standard Meal Type</Label>
                                                <Select  
                                                    value= {this.state.selectedMealType}
                                                    onChange = {(e) => this.setState({selectedMealType:e})}
                                                    options={HotelMealType}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        
                                                                        
                                    </Row>
                                    <Row>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Executive Packege Type</Label>
                                                <Select  
                                                    value= {this.state.selectedExecutivePackegeType}
                                                    onChange = {(e) => this.setState({selectedExecutivePackegeType:e})}
                                                    options={ExecutiveTypeGroup}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Executive Meal Type</Label>
                                                <Select  
                                                    value= {this.state.selectedExecutiveMealType}
                                                    onChange = {(e) => this.setState({selectedExecutiveMealType:e})}
                                                    options={HotelMealType}
                                                    classNamePrefix="select2-selection"
                                                />
                                            </div>
                                        </Col>
                                        

                                    </Row>
                                                    
                                    <FormGroup className="mb-0">
                                    {this.state.typeloading?(
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ):(
                                        <div>
                                    
                                    <Button type="submit" color="primary" className="me-1">
                                        Calculate
                                    </Button>
                                    </div>
                                        )}
                                    </FormGroup>     
                            </AvForm>
                        </Col>
                        <Col sm='3'>
                        </Col>

                    </Row>
                   
                   {this.state.calculated?
                   <>
                   <div style={{breakAfter:'page'}}></div>
                   <Row>
                    {!this.state.print?
                            <Col sm="3"></Col>
                            :null}
                        <Col sm={!this.state.print? "6": '12'}>
                            <div className="table-responsive">
                                <Table className="table-nowrap mb-0">
                                <thead>
                                    <tr>
                                
                                        <th scope="col" colSpan={2} style={{textAlign: 'center',  border: "solid 1px"}}>{"Hotel Details"}</th>
                                        <th scope="col" colSpan={2} style={{textAlign: 'center',  border: "solid 1px"}}>{'Vehicle Details'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    <tr>
                                        <td style={{textAlign: 'center',  border: "solid 1px"}}>Standard</td>
                                        <td style={{textAlign: 'center',  border: "solid 1px"}}>Executive</td>
                                        <td style={{textAlign: 'center',  border: "solid 1px"}}>Standard</td>
                                        <td style={{textAlign: 'center',  border: "solid 1px"}}>Executive</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "solid 1px"}}>
                                            
                                            {/* <p><b>Name: </b> {this.state.hotel_standard?.name}</p> */}
                                            <p><b>Double: </b> {this.state.hotel_standard?.double_count}</p>
                                            {/* <p><b>Triple: </b> {this.state.hotel_standard?.triple_count}</p> */}
                                            <p><b>Extra Bed: </b>{this.state.hotel_standard?.extra_bed}</p>
                                        </td>
                                        <td style={{ border: "solid 1px"}}>
                                            
                                            {/* <p><b>Name: </b> {this.state.hotel_executed?.name}</p> */}
                                            <p><b>Double: </b> {this.state.hotel_executed?.double_count}</p>
                                            
                                        </td>
                                        <td style={{ border: "solid 1px"}}>
                                    
                                            {/* <p><b>Name: </b> {this.state.vehicle_standard?.name}</p> */}
                                            <p><b>Type: </b> {this.state.vehicle_standard?.type}</p>
                                            <p><b>Seates: </b> {this.state.vehicle_standard?.seates}</p>
                                            
                                        </td>
                                        <td style={{ border: "solid 1px"}}>
                                            
                                            {/* <p><b>Name: </b> {this.state.vehicle_executed?.name}</p> */}
                                            <p><b>Type: </b> {this.state.vehicle_executed?.type}</p>
                                            <p><b>Seates: </b> {this.state.vehicle_executed?.seates}</p>
                                        </td>
                                    </tr>
                                    
                                    
                                    
                                </tbody>
                                </Table>
                            </div>
                        

                        </Col>
                        {!this.state.print?
                        <Col sm="3"></Col>
                        :null}

                   </Row>
                    <Row>
                        {!this.state.print?
                        <Col sm="3"></Col>
                        :null}
                        
                        <Col sm={!this.state.print? "6": '12'}>
                            <h5 className='my-3'>Packege Pricing</h5>
                            <div className="table-responsive">
                                <Table className="table-nowrap mb-0">
                                <thead>
                                    <tr>
                                
                                        <th scope="col" style={{border: "solid 1px"}}></th>
                                        <th scope="col" colSpan={2} style={{textAlign: 'center', border: "solid 1px"}}>{this.state.selectedPackegeType.label}</th>
                                        <th scope="col" colSpan={2} style={{textAlign: 'center', border: "solid 1px"}}>{this.state.selectedExecutivePackegeType.label}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                
                                        <td style={{ border: "solid 1px"}}></td>
                                        <td style={{textAlign: 'center',background: 'silver', border: "solid 1px"}}>On Season</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>Off Season</td>
                                        <td style={{textAlign: 'center', background: 'silver', border: "solid 1px"}} >On Season</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}} >Off Season</td>
                                    </tr>
                                    <tr>
                            
                                        <th style={{border: "solid 1px"}}>Price</th>
                                        <td style={{textAlign: 'center' , background: 'silver' , border: "solid 1px"}}>₹ {this.state.standard_onseason}</td>
                                        <td style={{textAlign: 'center' , border: "solid 1px"}}>₹ {this.state.standard_offseason}</td>
                                        <td style={{textAlign: 'center', background: 'silver' , border: "solid 1px"}}>₹ {this.state.executed_onseason}</td>
                                        <td style={{textAlign: 'center' , border: "solid 1px"}}>₹ {this.state.executed_offseason}</td>
                                    </tr>
                                    <tr>
                                

                                        <th style={{border: "solid 1px"}}><b>Taxes @5</b></th>
                                        <td style={{textAlign: 'center' , background: 'silver', border: "solid 1px"}}>₹ {this.state.standard_onseason_tax}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.standard_offseason_tax}</td>
                                        <td style={{textAlign: 'center', background: 'silver', border: "solid 1px"}}>₹ {this.state.executed_onseason_tax}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.executed_offseason_tax}</td>
                                    </tr>
                                    <tr>
                        

                                        <th style={{border: "solid 1px"}}><b>Margin @12</b></th>
                                        <td style={{textAlign: 'center', background: 'silver', border: "solid 1px"}}>₹ {this.state.standard_onseason_matgin}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.standard_offseason_matgin}</td>
                                        <td style={{textAlign: 'center', background: 'silver', border: "solid 1px"}}>₹ {this.state.executed_onseason_matgin}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.executed_offseason_matgin}</td>
                                    </tr>
                                    <tr>
                                

                                        <th style={{border: "solid 1px"}}><b>Total Tour Cost</b></th>
                                        <td style={{textAlign: 'center' , background: 'silver', border: "solid 1px"}}>₹ {this.state.standard_onseason_total}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.standard_offseason_total}</td>
                                        <td style={{textAlign: 'center', background: 'silver', border: "solid 1px"}}>₹ {this.state.executed_onseason_total}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.executed_offseason_total}</td>
                                    </tr>
                                    <tr>
                                
                                        <th style={{border: "solid 1px"}}><b>Per Pax Cost</b></th>
                                        <td style={{textAlign: 'center', background: 'silver', border: "solid 1px"}}>₹ {this.state.standard_onseason_perpax}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.standard_offseason_perpax}</td>
                                        <td style={{textAlign: 'center', background: 'silver', border: "solid 1px"}}>₹ {this.state.executed_onseason_perpax}</td>
                                        <td style={{textAlign: 'center', border: "solid 1px"}}>₹ {this.state.executed_offseason_perpax}</td>
                                    </tr>
                                    
                                    
                                </tbody>
                                </Table>
                            </div>
                            {this.state.print?null
                            :
                            // <Row>
                            //     <Col sm="4">
                            //     </Col>
                            //     <Col sm="4" className='my-4' style={{display:'flex', justifyContent:'center'}}>
                            //         {/* <Button type="submit" color="primary" className="mt-4">
                            //             Download
                            //         </Button> */}
                            //         <Link to="#" style={{textAlign:"left"}}  onClick={()=> this.toPrint()} className="btn btn-primary btn-rounded w-lg me-2">
                            //             <i className="fas fa-print font-size-15"></i> 
                            //             Print/Download
                            //         </Link>
                            //     </Col>
                            //     <Col sm="4">
                            //     </Col>
                            // </Row>
                            null
                            }
                           </Col>
                           {!this.state.print?
                            <Col sm="3"></Col>
                            :null}
                     
                        

                    </Row>
                    </>
                    :
                    null}
                 </ModalBody>
               </Modal>
             </Col>


            
                
            </React.Fragment>
        );
    }
}

export default Calculator;